import Model, { hasMany } from '@ember-data/model';
import type { AsyncHasMany } from '@ember-data/model';

import type UserDocumentLinkModel from './user-document-link';

export default class UserDocumentLinkable extends Model {
  @hasMany('user-document-link', { as: 'user-document-linkable', async: true, inverse: 'userDocumentLinkable' })
  declare userDocumentLinks: AsyncHasMany<UserDocumentLinkModel>;
}
